import Vue from 'vue'
import App from './App.vue'
import store from './store'

/**
 * Plugins
 */
import '@/plugins/bootstrap-vue';
import '@/plugins/globals';

//import '@/plugins/iview';
/**
 * Styles
 */
import "@/assets/css/main.scss";

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
